import * as React from 'react'
import styled from 'styled-components'
import { I18nCatalogue } from '../../i18n/reservation/types'
import { routeFactories } from '../../routes'
import { colors, devices } from '../../styleConstants'
import { HairStylist } from '../../types/hairStylist'
import { Menu } from '../../types/menu'
import { Avatar } from '../common/Avatar'
import { numberToCommaSeparatedString } from '../../utils/text'

interface Props {
  stylist: HairStylist
  menus: Menu[]
  catalogue: I18nCatalogue
}

export function ReservationContents({ stylist, menus, catalogue }: Props) {
  return (
    <Root>
      <Heading>{catalogue.reservationMenu}</Heading>
      <Content>
        {menus.length > 0 && (
          <MenuWrapper>
            <MenuTable>
              {menus.map(menu => {
                return (
                  <>
                    <tr>
                      <th>
                        {menu.special_spot && `【${menu.special_spot.name}】`}
                        {menu.menu_ja}
                      </th>
                    </tr>
                    <tr style={{ float: 'right' }}>
                      <td>
                        ¥{numberToCommaSeparatedString(menu.price)} ({catalogue.excludingTax})
                      </td>
                    </tr>
                  </>
                )
              })}
            </MenuTable>
            <div style={{ paddingTop: '12px' }}>{catalogue.selectableMenu}</div>
          </MenuWrapper>
        )}
        <StylistInfo>
          <Info>
            <Table>
              <tr>
                <th>{catalogue.stylist}</th>
                <td>
                  {stylist.name_ja}
                  <br />
                  {stylist.name_en}
                </td>
              </tr>
              {stylist.salons.length > 0 && (
                <tr>
                  <th>{catalogue.salon}</th>
                  <td>{stylist.salons.map(salon => salon.name).join(', ')}</td>
                </tr>
              )}
            </Table>
          </Info>
          <Image>
            <Avatar src={stylist.image} alt={stylist.name} route={routeFactories.stylists.getRoute(stylist.id)} />
          </Image>
        </StylistInfo>
      </Content>
    </Root>
  )
}

const Root = styled.div`
  padding: 20px;
  background-color: ${colors.secondaryExtraLight};
`

const Heading = styled.h1`
  margin: 0;
  padding-bottom: 20px;
  font-size: 22px;
  font-weight: normal;
  line-height: 30px;
  color: ${colors.secondary};
`

const Content = styled.div`
  display: flex;

  @media ${devices.mobile} {
    display: block;
  }
`
const StylistInfo = styled.div`
  width: 560px;

  @media ${devices.mobile} {
    width: 100%;
    display: flow-root;
  }
`

const Image = styled.div`
  width: 145px;
  border: 1px solid #ccc;
  line-height: 0;
  display: inline-block;
  float: right;

  @media ${devices.mobile} {
    margin: auto;
    margin-top: 24px;
    float: none;
    display: flex;
  }
`

const Info = styled.div`
  flex: 1;
  float: left;
  margin: 24px 0px;
`

const Table = styled.table`
  margin-left: 40px;
  border: none;

  @media ${devices.mobile} {
    margin: 20px 0px;
  }

  th,
  td {
    padding: 0;
    border: none;
    font-size: 14px;
    font-weight: normal;
    line-height: 20px;
    text-align: left;
    vertical-align: top;
  }

  tr + tr {
    th,
    td {
      padding-top: 20px;
    }
  }

  th {
    /* 文字幅に合わせる */
    width: 1px;
    white-space: nowrap;
    color: #999;
  }

  td {
    padding-left: 20px;
    color: ${colors.black};
  }
`

const MenuWrapper = styled.div`
  border-right: 1px solid #c4c4c4;
  @media ${devices.mobile} {
    border-right: none;
    border-bottom: 1px solid #c4c4c4;
  }
`

const MenuTable = styled(Table)`
  width: 400px;
  margin-right: 40px;
  th {
    font-size: 16px;
  }
  td {
    font-size: 14px;
  }

  tr + tr {
    th,
    td {
      padding-top: 6px;
    }
  }
  margin-top: 16px;
  margin-bottom: 16px;

  @media ${devices.mobile} {
    width: 100%;
    th {
      white-space: normal;
    }
  }
`
